import { authStorage } from '../storage/authStorage';

export interface RedirectToAdminWithHandoffParams {
	createHandoff: (rememberMe: boolean) => Promise<string>;
	createAppLink: (app: 'admin', route: 'home' | 'dashboard') => string;
}

export const redirectToAdminWithHandoff = async ({
	createHandoff,
	createAppLink,
}: RedirectToAdminWithHandoffParams): Promise<void> => {
	const rememberMe = authStorage.isRemembered();
	let redirectUrl = createAppLink('admin', 'dashboard');

	try {
		const code = await createHandoff(rememberMe);
		redirectUrl = `${createAppLink('admin', 'home')}/auth/exchange?code=${encodeURIComponent(code)}`;
	} catch {
		redirectUrl = createAppLink('admin', 'dashboard');
	}

	authStorage.clearSession();
	globalThis.location.assign(redirectUrl);
};
